import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=6a245c10"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCategory: require('/opt/build/repo/components/product/Category.vue').default,ProductCondition: require('/opt/build/repo/components/product/Condition.vue').default,ProductStatus: require('/opt/build/repo/components/product/Status.vue').default})
